import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const problems = ['Terminás sintiéndote insegura después de algunas entrevistas', 'Dudás al hacer informes o devoluciones', 'Sentís que improvisás demasiado', 'No sabés cómo organizar evaluaciones', 'Te cuesta estructurar intervenciones', 'Sentís presión en reuniones con familias', 'No sabés si lo estás haciendo “bien”', 'La organización clínica te desborda', 'Te cuesta poner límites profesionales', 'Sentís que la facultad no preparó para la práctica real'];
export function PainPointsSection() {
  return <section className="py-24 relative" data-id="element-140">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-141">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-142">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-navy-900 mb-6 uppercase tracking-tight" data-id="element-143">
            ¿Sentís que la clínica real te genera inseguridad?
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-144">
            Muchas veces el verdadero problema no es la falta de capacidad.
            <br data-id="element-145" />
            <span className="font-semibold text-violet-700" data-id="element-146">
              Es sentir que nadie te enseñó cómo sostener la práctica clínica
              real.
            </span>
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl p-8 md:p-12 shadow-md border border-slate-100 mb-12" data-id="element-147">
          <h3 className="text-sm font-bold text-slate-400 uppercase tracking-widest mb-8 text-center" data-id="element-148">
            Problemas Frecuentes
          </h3>

          <div className="grid md:grid-cols-2 gap-x-8 gap-y-4" data-id="element-149">
            {problems.map((problem, i) => <div key={i} className="flex items-start gap-3" data-id="element-150">
                <XCircle className="w-5 h-5 text-red-400 shrink-0 mt-0.5" data-id="element-151" />
                <span className="text-slate-700 font-medium" data-id="element-152">{problem}</span>
              </div>)}
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-153">
          <p className="font-serif italic text-2xl md:text-3xl text-teal-600 max-w-3xl mx-auto leading-relaxed" data-id="element-154">
            "No necesitás hacerlo perfecto. Necesitás herramientas más claras
            para sentirte más segura."
          </p>
        </motion.div>
      </div>
    </section>;
}